import { FC } from 'react';

import ChangePasswordForm from '@/components/layout/changePasswordPage/ChangePasswordForm';

const ChangePassword: FC = () => {
  return (
    <div className="w-full max-w-2xl mx-auto md:ml-10 xl:ml-28 mt-8 md:mt-12 flex flex-col md:flex-row gap-4 px-4 items-start">
      <div className="flex-1 w-full text-center md:text-left">
        <ChangePasswordForm />
      </div>
    </div>
  );
};

export default ChangePassword;
